





































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
    return new proxy.FinancialStatisticsServiceProxy();
  }
  input :proxy.MerchantAndChannelTypeDayBillPageInputDto = new proxy.MerchantAndChannelTypeDayBillPageInputDto();
  createrange = [];
  PayChannels=[];
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '商户',
      key: 'merName'
    },
    {
      title:'商户号',
      key:'mid'
    },
    {
      title: '产品',
      key: 'channelTypeName'
    },
    {
        title:'产品编码',
        key:'channelTypeCode'
    },
    {
      title: '成功笔数',
      key: 'orderNum'
    },
    {
      title:'总跑',
      key:'money'
    },
    {
      title: '服务费',
      key: 'commission'
    },
    {
        title:'商户实到金额',
        key:'payMoney'
    },

    
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.prox.queryMerchantChannelTypeList(this.input).then(x => {
      this.dataList = x;
      this.showPaging(x);
    });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    let req = new proxy.ChannelSimpleInputDto();
    new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
      this.PayChannels = x;
    });
    this.getpage();
  }
}
